"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetched = isFetched;
exports.fetchImage = fetchImage;
var fetched = {};

function isFetched(src) {
  return fetched[src];
}

function fetchImage(src) {
  if (isFetched(src)) {
    return Promise.resolve();
  }

  return new Promise(function (resolve, reject) {
    var img = new Image();

    var onload = function onload() {
      fetched[src] = true;
      resolve();
    };

    img.onerror = reject;
    img.onload = onload;
    img.src = src;
  });
}